import { useDropsPageQuery } from "src/components/drops/DropsPage.generated";
import { DropsPageView } from "src/components/drops/DropsPageView";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useDevelopmentContext } from "src/routes/developments/context/DevelopmentContext";
import { DevelopmentParams } from "src/routes/routesDef";

export function DevelopmentDropsPage() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  const { name } = useDevelopmentContext();
  const query = useDropsPageQuery({ variables: { filter: { development: [developmentId] }, entityId: developmentId } });

  return <DropsPageView query={query} documentTitleSuffix={name} />;
}
